import { render, staticRenderFns } from "./AdminLogout.vue?vue&type=template&id=d60017d6&scoped=true&"
import script from "./AdminLogout.vue?vue&type=script&lang=js&"
export * from "./AdminLogout.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogout.vue?vue&type=style&index=0&id=d60017d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60017d6",
  null
  
)

export default component.exports